import { Link } from "react-router-dom";
import banner1 from "../assets/images/banner1.png";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center p-6 overflow-hidden">
      {/* Background dengan blur */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105 blur-sm"
        style={{ backgroundImage: `url(${banner1})` }}
      ></div>

      {/* Overlay agar lebih gelap */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Konten di atasnya */}
      <div className="relative z-10 text-white">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
        <p className="text-gray-200 mb-8">
          The page you’re looking for doesn’t exist or is under construction.
        </p>

        <Link
          to="/"
          className="bg-primary text-white hover:text-black px-6 py-3 rounded-lg font-medium hover:bg-secondary transition-all"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
